<template>
  <div class="artist-dashboard">
    <v-container>
      <!-- HEADER -->
      <v-row>
        <v-col cols="12" class="text-center">
          <h3 class="glow">🎧 AI Artist Explorer</h3>
          <p><strong>Total Artists:</strong> {{ artistList.length }}</p>
        </v-col>
      </v-row>

      <!-- GPT BUTTONS + INPUT -->
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn @click="askCategory('Top 100 Touring Artists')" class="ma-2">Top 100</v-btn>
          <v-btn @click="askCategory('Top 50 Artists of 2025')" class="ma-2">Top 50</v-btn>
          <v-btn @click="askCategory('Best Independent Artists Now')" class="ma-2">Indie Picks</v-btn>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12">
          <v-textarea
            v-model="question"
            label="Ask ChatGPT (or paste artists)"
            outlined
            rows="2"
          />
        </v-col>
        <v-col cols="12">
          <v-btn block color="secondary" @click="askQuestion" :loading="loading">
            Ask ChatGPT
          </v-btn>
        </v-col>
      </v-row>

      <!-- GPT RESPONSE -->
      <v-row v-if="response.gptMessage">
        <v-col cols="12">
          <v-alert type="info" border="left" colored-border>
            {{ response.gptMessage }}
          </v-alert>
          <v-btn text small @click="importArtists(response.gptMessage)">+ Add to List</v-btn>
        </v-col>
      </v-row>

      <!-- MANUAL ADD -->
      <v-row>
        <v-col cols="12" md="8">
          <v-autocomplete
            v-model="selectedArtist"
            :items="artistList"
            label="Select or Search Artist"
            dense outlined clearable
          />
        </v-col>
        <v-col cols="12" md="4">
          <v-text-field
            v-model="newArtistName"
            label="Add New Artist"
            dense outlined
          />
          <v-btn block small color="primary" @click="addNewArtist">Add</v-btn>
        </v-col>
      </v-row>

      <!-- ARTIST CHIPS -->
      <v-row>
        <v-col cols="12">
          <v-chip
            v-for="(artist, index) in topArtists"
            :key="artist"
            close
            class="animated-chip"
            @click="selectFromChip(artist)"
            @click:close="removeArtist(index)"
          >
            {{ artist }}
          </v-chip>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "ArtistDashboard",
  data() {
    return {
      artistList: [],
      selectedArtist: "",
      newArtistName: "",
      question: "",
      response: {},
      loading: false,
      gptApiKey: "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", // Replace with your key
    };
  },
  computed: {
    topArtists() {
      return this.artistList.slice(0, 50);
    },
  },
  mounted() {
    const saved = localStorage.getItem("artistList");
    if (saved) this.artistList = JSON.parse(saved);
  },
  methods: {
    addNewArtist() {
    const name = this.cleanArtistName(this.newArtistName);
    if (name && !this.artistList.includes(name)) {
      this.artistList.unshift(name);
      this.saveToLocalStorage();
    }
    this.newArtistName = "";
  },
  importArtists(text) {
    const lines = text.split(/\n|,|•|-|–/);
    const cleaned = lines
      .map((line) => this.cleanArtistName(line))
      .filter((name) => name && !this.artistList.includes(name));

    this.artistList = [...cleaned, ...this.artistList];
    this.artistList = [...new Set(this.artistList)]; // remove dupes
    this.saveToLocalStorage();
  },
  cleanArtistName(name) {
    // Remove digits, punctuation, symbols, and extra spaces
    return name
      .replace(/[^a-zA-Z\s]/g, "") // keep only letters and spaces
      .replace(/\s+/g, " ") // normalize spaces
      .trim(); // remove leading/trailing spaces
  },
  removeArtist(index) {
    this.artistList.splice(index, 1);
    this.saveToLocalStorage();
  },
  selectFromChip(artist) {
    this.selectedArtist = artist;
  },
  saveToLocalStorage() {
    localStorage.setItem("artistList", JSON.stringify(this.artistList));
  },
  askCategory(category) {
    this.question = `List the ${category}`;
    this.askQuestion();
  },
  async askQuestion() {
    if (!this.question.trim()) return;
    this.loading = true;
    this.response = {};
    try {
      const gptRes = await this.askChatGPT(this.question);
      this.response.gptMessage = gptRes;
    } catch (err) {
      console.error("GPT Error:", err);
      this.response.gptMessage = "Failed to retrieve response.";
    } finally {
      this.loading = false;
    }
  },
  async askChatGPT(prompt) {
    const res = await axios.post(
      "https://api.openai.com/v1/chat/completions",
      {
        model: "gpt-4",
        messages: [{ role: "user", content: prompt }],
        max_tokens: 4000,
        temperature: 0.2,
        top_p: 0.9,
        n: 1,
      },
      {
        headers: {
          Authorization: `Bearer ${this.gptApiKey}`,
          "Content-Type": "application/json",
        },
      }
    );
    return res.data.choices[0].message.content.trim();
  },
    // importArtists(text) {
    //   const extracted = text
    //     .split(/\n|,|•|-|–/)
    //     .map((a) => a.trim())
    //     .filter((a) => a.length > 1 && isNaN(a))
    //     .filter((val, i, self) => self.indexOf(val) === i); // remove dupes
    //   extracted.forEach((artist) => {
    //     if (!this.artistList.includes(artist)) {
    //       this.artistList.unshift(artist);
    //     }
    //   });
    //   this.saveToLocalStorage();
    // },
  },
};
</script>

<style scoped>
.artist-dashboard {
  background: #0e0f1c;
  color: white;
  padding: 20px;
  font-family: "Orbitron", "Share Tech Mono", sans-serif;
}
.glow {
  color: #00ffe5;
  text-shadow: 0 0 5px #00ffe5, 0 0 10px #00d4ff;
}
.v-btn {
  background-color: #1e1f2f !important;
  color: #00fff2 !important;
  border-radius: 8px;
}
.animated-chip {
  animation: fadeInUp 0.3s ease;
}
@keyframes fadeInUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
